import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class PrescriptionPadService extends BaseService() {
    static get entity() {
        return "prescription_pad";
    }
    static get responseName() {
        return "prescription_pads";
    }
    static getIndex(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `${this.entity}?page=${payload.page}`,
                isFullPath: true,
                data: payload,
            });
        });
    }
    static store(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `${this.entity}`,
                isFullPath: true,
                data: payload,
                responseName: "response",
            });
        });
    }
    static getByProfessional(patient_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_professional_id/${patient_id}`,
            });
        });
    }
    static addProfessional(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `add_professional`,
                data: payload,
            });
        });
    }
    static change_professional(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `change_professional`,
                data: payload,
            });
        });
    }
}
